import React, { useState, useMemo /*useEffect*/ } from 'react'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { ContextBar, ContextButton, Detail, SelectBox, TextInput } from '@tecuity/granite-ui'
import './ReceiptValidation.scss'
import format from 'date-fns/format'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import PencileIcon from '@tecuity/sos-icons/react/pencil-solid'
import { DatePicker } from '@tecuity/granite-ui/DatePicker'
import CalendarIcon from '@tecuity/sos-icons/react/calendar'
import { shallowEqual, useSelector } from 'react-redux'
import CaretLeftIcon from '@tecuity/sos-icons/react/caret-left'

const Refund = ({ refund, setRefund, editMode, setEditMode, receiptStatus, isDirty }) => {
  return (
    <DetailCard
      label={'Refund'}
      className="detailsCard"
      customCss={{ width: '60%', marginBottom: '10px' }}
    >
      <div className="row" style={{ display: 'flex', justifyContent: 'space-between' }}>
        {!editMode ? (
          <RefundDisplay
            refund={refund}
            setEditMode={setEditMode}
            receiptStatus={receiptStatus}
            isDirty={isDirty}
          />
        ) : (
          <RefundEdit refund={refund} setRefund={setRefund} setEditMode={setEditMode} />
        )}
      </div>
    </DetailCard>
  )
}

const RefundDisplay = ({ refund = {}, setEditMode, receiptStatus, isDirty }) => {
  const { appUserRights } = useSelector((state) => state.auth, shallowEqual)

  const canEdit = useMemo(() => {
    if (refund.RefundStatusID == 666 && !isDirty) {
      //Refund Cancelled
      return false
    }

    if (receiptStatus != 517) {
      //Receipt Reconciled
      return false
    }

    return appUserRights.includes('ReceiptEditRefundInfo')
  }, [refund, receiptStatus, appUserRights])

  const refundDetails = useMemo(() => {
    return [
      { value: refund.RefundBy, label: 'Refund By' },
      {
        value: format(new Date(refund.RefundDate || new Date()), 'MM/dd/yyyy'),
        label: 'Refund Date',
      },
      { value: refund.RefundNum, label: 'Refund Number' },
      { value: refund.RefundStatus, label: 'Refund Status' },
    ]
  }, [refund])

  return (
    <React.Fragment>
      {refundDetails.map((detail, index) => {
        return <Detail key={index} label={detail.label} children={detail.value} />
      })}
      {canEdit ? (
        <span title={'Edit Payment Details'}>
          <IconButton
            onClick={() => setEditMode(true)}
            icon={<PencileIcon />}
            label="Edit Refund Details"
            customCss={'padding: 5px !important; margin-left: 4px;'}
          />
        </span>
      ) : null}
    </React.Fragment>
  )
}

const RefundEdit = ({ refund, setRefund, setEditMode }) => {
  const [displayDatePicker, setDisplayDatePicker] = useState(false)
  const { refundStatuses } = useSelector((state) => state.receipt, shallowEqual)
  const { FIRST_NAME, LAST_NAME } = useSelector((state) => state.auth, shallowEqual)
  // 000201217
  return (
    <React.Fragment>
      <div>
        <TextInput
          label={'Refund By'}
          value={`${FIRST_NAME} ${LAST_NAME}`}
          disabled={true}
        ></TextInput>
      </div>
      <div className={'date-picker-holder'}>
        <TextInput
          label={'Refund Date'}
          value={format(new Date(refund.RefundDate), 'MM/dd/yyyy')}
        ></TextInput>
        <button onClick={() => setDisplayDatePicker(true)}>
          <CalendarIcon size={'small'}></CalendarIcon>
        </button>
        <DatePicker
          onChange={(e) => setRefund({ ...refund, RefundDate: format(new Date(e), 'MM/dd/yyyy') })}
          onCalendarClose={() => setDisplayDatePicker(false)}
          isOpen={displayDatePicker}
        />
      </div>
      <div>
        <TextInput
          label={'Refund Number'}
          value={refund.RefundNum}
          onChange={(e) => setRefund({ ...refund, RefundNum: e.target.value })}
        />
      </div>
      <div>
        <SelectBox
          label={'Refund Status'}
          options={refundStatuses}
          value={refund.RefundStatusID}
          onChange={(e) => {
            let status = refundStatuses.find((x) => x.value == e)
            setRefund({ ...refund, RefundStatusID: status.value, RefundStatus: status.label })
          }}
        />
      </div>
      <div>
        <IconButton
          onClick={() => setEditMode(false)}
          icon={<CaretLeftIcon />}
          label="Edit Refund Details"
          customCss={'padding: 5px !important; margin-left: 4px;'}
        />
      </div>
    </React.Fragment>
  )
}

export default Refund

export const RefundModal = ({ skipCancelledReceipt, createCancelledReceipt }) => {
  return (
    <div className={'receipt-modal'}>
      <div className={'context-bar-refund-details'}>
        The Refund related to this receipt has been cancelled. Would you like to create a receipt to
        deposit the cancelled amount to an account?
      </div>
      <ContextBar className={'modal-context-bar'}>
        <div className={'context-bar-refund-content-bar'}>
          <ContextButton variant={'success'} onClick={createCancelledReceipt}>
            Yes
          </ContextButton>
          <ContextButton variant={'danger'} onClick={skipCancelledReceipt}>
            No
          </ContextButton>
        </div>
      </ContextBar>
    </div>
  )
}
